import * as request from '../../utils/request'


export async function GetSearchInfo(url, props, msg) {
    return await request.postData(url, props, msg);
}
export async function GetMCDetail(url, props, msg) {
    return await request.postData(url, props, msg);
}
export async function GetPackListData(url, props, msg) {
    return await request.postData(url, props, msg);
}
export async function GetSearchInfo2(url, props, msg) {
    return await request.postData(url, props, msg);
}
//获取体检中心列表 
////api/mcc/midcail/page/list
//level
//county
//isenable
//rows
//page
//city
export async function GetPageMidcailCenter(parameter, msg) {
    return await request.fetchData(global.constants.api_tj + `api/mcc/midcail/page/list?page=${parameter.page}&county=${parameter.county}&isenable=${parameter.isenable}&level=${parameter.level}&rows=${parameter.rows}&city=${parameter.city}`, msg);
}
//获取体检中心详情 /api/mcc/details
//mcno 体检编号
export async function GetHospitalDetails(mcno, msg) {
    return await request.fetchData(global.constants.api_tj + `api/mcc/details?mcno=${mcno}`, msg);
}
//根据体检中心获取套餐列表 /api/mp/pack/packbasistypelist
//mcno 体检编号
export async function GetHospitalItem(mcno, msg) {
    let url=request.addTimestamp(global.constants.api_tj + `api/mp/pack/packbasistypelist?mcno=${mcno}`);
    return await request.fetchData(url, msg);
}

//根据体检中心编号获取排班信息 api/sm/schedule/loadcalendar  mcno=057401
export async function GetJsonExamDate(mcno, msg) {
    return await request.fetchData(global.constants.api_tj + `api/sm/schedule/loadcalendar?mcno=${mcno}`, msg);
}
//获取体检中心是否自定义配置 //api/mcc/midcail/config
export async function GetMidcailConfig(mcno, msg) {
    return await request.fetchData(global.constants.api_tj + `api/mcc/midcail/config?mcno=${mcno}`, msg);
}


//获取套餐列表 packlist api/mp/pack/list global.constants.api_tj
// mcno:'',//体检中心编码
// level:'',//医院等级
// packtypeid:[],//体检套餐类型
// startprice:'',//价格区间，开始价格
// endprice:'',//价格区间，结束价格
// rows:rows,
// page:page,
export async function GetPacklist(parameter, typeidlist, msg) {
    let curl = '';
    for (let i = 0; i < typeidlist.length; i++) {
        curl += `&packtypeid=${typeidlist[i]}`;
    }
    curl=request.addTimestamp(global.constants.api_tj + `api/mp/pack/list?city=${parameter.city}&mcno=${parameter.mcno}&level=${parameter.level}&startprice=${parameter.startprice}&endprice=${parameter.endprice}&rows=${parameter.rows}&page=${parameter.page}` + curl);
    return await request.fetchData(curl, msg);
}
//获取专属套餐和标准套餐 12.	api/pack/list
//修改 api/pack/filter
// 参数：mcno,applyId, clientId  peopleId
export async function GetPacklist2(parameter, msg) {
    let url=request.addTimestamp(global.constants.api_tj + `api/pack/filter?mcno=${parameter.mcno}&applyId=${parameter.applyId}&clientId=${parameter.clientId}&peopleId=${parameter.peopleId}`);
    return await request.fetchData(url, msg);
}
//获取套餐详情 api/pack/detailssort 给项目分类
export async function GetPackdetail(packId, msg) {
    return await request.fetchData(global.constants.api_tj + `api/pack/detailssort?packId=${packId}`, msg);
}
//获取专属套餐详情 api/crm/pack/details
export async function GetCrmPackdetail(packId, msg) {
    return await request.fetchData(global.constants.api_tj + `api/crm/pack/details?packId=${packId}`, msg);
}
//获取套餐项目列表/api/pack/item
//packId 套餐id
export async function GetPackitem(packId, msg) {
    return await request.fetchData(global.constants.api_tj + `api/pack/item?opid=${packId}`, msg);
}
//获取套餐项目列表2 专属、自定义套餐、标准套餐 api/mm/order/item/List
export async function GetMMPackitem(opId, msg) {
    return await request.fetchData(global.constants.api_tj + `api/mm/order/item/List?opId=${opId}`, msg);
}
//根据城市获取区域列表 
// /api/stm/county/listbycode
// 根据城市编码获取区/县 列表
export async function GetListbycode(code, msg) {
    return await request.fetchData(global.constants.api_tj + `api/stm/county/listbycode?code=${code}`, msg);
}
//获取体检中心项目/api/item/list
export async function GetListbyitem(parameter, msg) {

    return await request.fetchData(global.constants.api_tj + `api/item/list?McNO=${parameter.McNO}&peopleId=${parameter.peopleId}`, msg);
}
//获取当前套餐体检项目/api/pack/item
export async function Getpackbyitem(packId, msg) {
    return await request.fetchData(global.constants.api_tj + `api/pack/item?packId=${packId}`, msg);
}

//获取字典信息
//name
/// 根据字典名称获取对应的数据
/// /api/stm/dic/list
/// <param name="name"></param>
/// <param name="name">性别,性质,等级,项目类型分类方式,适用性别,适用婚姻状况,套餐类型分类方式,功能类型,是否必选,
/// 项目关系类型,客户来源,客户类型,订单来源,订单状态,排班来源,充值卡状态,充值方式,操作类型,充值来源,是否联盟,
/// 预约状态,意见类型,支付方式,制卡状态,职业,学历,体检码状态,订单取消,验证类型,消费方式,消费来源,体检人标签</param>
export async function GetList(name, msg) {
    return await request.fetchData(global.constants.api_tj + `api/stm/dic/list?name=${name}`, msg);
}

//获取体检中心列表不分页treelist city
export async function GetTreelist(code, msg) {
    return await request.fetchData(global.constants.api_tj + `api/mcc/midcail/treelist?city=${code}`, msg);
}
//获取体检中心列表不分页treelist city 过滤没有报告的体检中心
export async function GetReportTreelist(code, msg) {
    return await request.fetchData(global.constants.api_tj + `api/mcc/midcail/reportlist?city=${code}`, msg);
}

//获取套餐适用人群和特色项目packtype
export async function GetPackTypelist(typeid, msg) {
    return await request.fetchData(global.constants.api_tj + `api/mp/packtype/list?propery=${typeid}`, msg);
}

//添加自定义套餐到购物车    /api/mm/cartcustom/add 
export async function AddCartcustom(data, msg) {
    return await request.postData(global.constants.api_tj + `api/mm/cartcustom/add`, data, msg);
}
//添加套餐到购物车  /api/mm/cart/add
export async function AddCart(data, msg) {
    return await request.postData(global.constants.api_tj + `api/mm/cart/add`, data, msg);
}
//获取购物车列表 /api/mm/cart/list
export async function GetCartList(msg) {
    let url=request.addTimestamp(global.constants.api_tj + `api/mm/cart/list`);
    return await request.fetchData(url, msg);
}
//购物车修改标准套餐 /api/mm/cart/edit
export async function EditCart(data, msg) {
    return await request.postData(global.constants.api_tj + `api/mm/cart/edit`, data, msg);
}
//购物车修改自定义套餐 /api/mm/cartcustom/edit
export async function EditCartcustom(data, msg) {
    return await request.postData(global.constants.api_tj + `api/mm/cartcustom/edit`, data, msg);
}
//购物车删除标准套餐 /api/mm/cart/del
export async function DelCart(packid, msg) {
    return await request.fetchData(global.constants.api_tj + `api/mm/cart/del?packid=${packid}`, msg);
}
//购物车删除自定义套餐 /api/mm/cartcustom/del
export async function DelCartCustom(cardid, msg) {
    return await request.fetchData(global.constants.api_tj + `api/mm/cartcustom/del?id=${cardid}`, msg);
}
//增加订单 /api/am/order/add 
export async function AddOrder(parameter, msg) {
    return await request.postData(global.constants.api_tj + `api/am/order/add`, parameter, msg);
}
//获取用户地址列表 /api/mm/address/list
export async function GetAddressList(msg) {
    return await request.fetchData(global.constants.api_tj + `api/mm/address/list`, msg);
}
//新增用户收货列表 api/mm/address/add
export async function AddAddress(data, msg) {
    return await request.postData(global.constants.api_tj + `api/mm/address/add`, data, msg);
}
//修改用户收货地址 8.	/api/mm/address/edit
export async function EditAddress(data, msg) {
    return await request.postData(global.constants.api_tj + `api/mm/address/edit`, data, msg);
}
//删除用户收货地址 /api/mm/address/del
export async function DelAddress(addressId, msg) {
    return await request.fetchData(global.constants.api_tj + `api/mm/address/del?addressId=${addressId}`, msg);
}
//获取所有省市区 /api/region/all/list
export async function GetAllList(msg) {
    return await request.fetchData(global.constants.api_tj + `api/region/all/list`, msg);
}
//查询订单列表 api/am/order/listpagepic
export async function GetOrderListpage(parameter, msg) {
    //Title rows page
    return await request.fetchData(global.constants.api_tj + `api/am/order/listpagepic?Title=${parameter.Title}&rows=${parameter.rows}&page=${parameter.page}`, msg);
}
//取消订单 	api/am/order/cancel
export async function CancelOrder(parameter, msg) {
    return await request.fetchData(global.constants.api_tj + `api/am/order/cancel?orderId=${parameter.orderid}&reason=${parameter.reason}`, msg);

}
//发送验证码 /api/sms/send/verify_code
//mobile
export async function SendVerifyCode(parameter, msg) {
    return await request.fetchData(global.constants.api_sso + `api/sms/send/verify_code?mobile=${parameter.mobile}`, msg);
}
//检查短信验证码 /api/sms/check/verify_code
//code id
export async function CheckVerifyCode(parameter, msg) {
    return await request.fetchData(global.constants.api_sso + `api/sms/check/verify_code?id=${parameter.id}&code=${parameter.code}`, msg);
}

//添加健康积分 api/mm/bind/card
export async function AddBindCard(parameter, msg) {
    return await request.postData(global.constants.api_tj + `api/mm/bind/card`, parameter, msg);
}
//  获取健康积分列表【积分余额、创建时间、过期时间】/api/user/card/list
export async function GetUserCardList(parameter, msg) {
    return await request.fetchData(global.constants.api_tj + `api/user/card/list?page=${parameter.page}&rows=${parameter.rows}`, msg);
}
//获取健康积分和范围 	api/mm/card/union/list
export async function GetCardUnionList(parameter, msg) {
    return await request.fetchData(global.constants.api_tj + `api/mm/card/union/list?page=${parameter.page}&rows=${parameter.rows}`, msg);
}
//获取健康积分详情 /api/bms/public/details
/// publicId
export async function GetIntegralD(publicId, msg) {
    return await request.fetchData(global.constants.api_yg + `api/bms/public/details?publicId=${publicId}`, msg);
}
//修改卡支付密码 /api/bms/prepaidpublc/updatepw
//PublicId
//newPassword
//oldPassword
export async function Updatepw(parameter, msg) {
    return await request.fetchData(global.constants.api_yg + `api/bms/prepaidpublc/updatepw?PublicId=${parameter.PublicId}&newPassword=${parameter.newPassword}&oldPassword=${parameter.oldPassword}`, msg);
}
//获取积分消费记录 /api/bms/operate/list
/// publicId
/// type
/// datetime
/// Rows
/// Page
export async function GetOperateList(parameter, msg) {
    return await request.fetchData(global.constants.api_yg + `api/bms/operate/list?Page=${parameter.page}&Rows=${parameter.rows}&datetime=${parameter.datetime}&type=${parameter.type}&publicId=${parameter.publicId}`, msg);
}
///获取积分卡的使用范围  api/stm/union/listpublic
export async function GetUnionListpublic(publicId, msg) {
    return await request.fetchData(global.constants.api_yg + `api/stm/union/listpublic?publicId=${publicId}`, msg);
}
///获取联盟体检中心  /api/stm/union/list
export async function GetUnionListpublic2(msg) {
    let url=request.addTimestamp(global.constants.api_yg + `api/stm/union/list`);
    return await request.fetchData(url, msg);
}
//获取常用体检人列表 api/mm/people/eplist
export async function GetPeopleList(opId,msg) {
    return await request.fetchData(global.constants.api_tj + `api/mm/people/eplist?opId=${opId}`, msg);
}
//添加常用体检人 /api/mm/people/add
export async function AddPeople(parameter, msg) {
    return await request.postData(global.constants.api_tj + `api/mm/people/add`, parameter, msg);
}
//修改常用体检人 /api/mm/people/edit
export async function EditPeople(parameter, msg) {
    return await request.postData(global.constants.api_tj + `api/mm/people/edit`, parameter, msg);
}
//删除常用体检人 /api/mm/people/del
export async function DelPeople(peopleId, msg) {
    return await request.fetchData(global.constants.api_tj + `api/mm/people/del?peopleId=${peopleId}`, msg);
}
//修改积分卡手机号码 /api/bms/prepaidpublc/updatemobile
//PublicId,Mobile,NewMobile
export async function Updatemobile(parameter, msg) {
    return await request.fetchData(global.constants.api_yg + `api/bms/prepaidpublc/updatemobile?PublicId=${parameter.PublicId}&Mobile=${parameter.Mobile}&NewMobile=${parameter.NewMobile}`, msg);
}
//忘记密码 /MemberApi/ModifyMemberPsw
///PublicId，Mobile，newPassword
//&purl2=/MemberApi/SendVCode
export async function ForgetUpdatepw(parameter, msg) {
    return await request.fetchData(global.constants.api_yg + `api/bms/prepaidpublc/mobile/updatepw?PublicId=${parameter.PublicId}&Mobile=${parameter.Mobile}&newPassword=${parameter.newPassword}`, msg);
}
//新增预约 api/am/orderment/add
export async function AddOrderment(parameter, msg) {
    return await request.postData(global.constants.api_tj + `api/am/orderment/add`, parameter, msg);
}
//新增预约 支付后预约 /api/am/orderment/Appointment
export async function AddOrdermentAppointment(parameter, msg) {
    return await request.postData(global.constants.api_tj + `api/am/orderment/Appointment`, parameter, msg);
}
//取消预约 /api/am/orderment/cancel
//cId  sId pId
export async function CancelOrderment(parameter, msg) {
    return await request.fetchData(global.constants.api_tj + `api/am/orderment/cancel?cId=${parameter.cId}&sId=${parameter.sId}&pId=${parameter.pId}`, msg);
}
//根据状态获取预约列表 api/am/credentials/lists 
//page,rows,status 
export async function GetCredentialsLists(parameter, msg) {
    return await request.fetchData(global.constants.api_tj + `api/am/credentials/lists?page=${parameter.page}&rows=${parameter.rows}&status=${parameter.status}`, msg);
}
//获取时间段 api/mcc/midcailtime/list
export async function MidcailtimeList(mcid, msg) {
    return await request.fetchData(global.constants.api_tj + `api/mcc/midcailtime/list?mcid=${mcid}`, msg);
}
//获取体检报告 api/mm/report/List
//page rows
export async function GetReportList(parameter, msg) {
    return await request.fetchData(global.constants.api_tj + `api/mm/report/List?page=${parameter.page}&rows=${parameter.rows}`, msg);
}
//新增体检报告 api/mm/report/add
export async function AddReport1(parameter, msg) {
    return await request.postData(global.constants.api_tj + `api/mm/report/add`, parameter, msg);
}
//自动匹配 新增体检报告 api/mm/report/addmatic
export async function Addmatic(parameter, msg) {
    return await request.postData(global.constants.api_tj + `api/mm/report/addmatic`, parameter, msg);
}
//自动匹配报告 	api/report/List
export async function GetReportListP(msg) {
    return await request.fetchData(global.constants.api_tj + `api/report/List`, msg);
}
//解绑报告 api/mm/report/relieve
export async function RelieveReport(reportId, msg) {
    return await request.fetchData(global.constants.api_tj + `api/mm/report/relieve?reportId=${reportId}`, msg);
}
//报告查询详情 /user/baogao/BaseInfo
export async function GetReportD(parameter, msg) {
    return await request.fetchData(global.constants.api_tj + `api/mm/report/info?tjbh=${parameter.tjbh}&password=${parameter.password}&hospitalno=${parameter.mcno}&format=json&resolution=2560*1080&from=1`, msg);
}
//新增报告解读 3.	api/mm/report/decode
export async function Adddecode(parameter, msg) {
    return await request.postData(global.constants.api_tj + `api/mm/report/decode`, parameter, msg);
}
//修改报告密码
//api/mm/report/modifypsw
//hospitalno,tjbh,oldpsw,newpsw,confirmpsw
export async function ModifyReportpsw(parameter, msg) {
    return await request.fetchData(global.constants.api_tj + `api/mm/report/modifypsw?hospitalno=${parameter.hospitalno}&tjbh=${parameter.tjbh}&oldpsw=${parameter.oldpsw}&newpsw=${parameter.newpsw}&confirmpsw=${parameter.confirmpsw}`, msg);
}
//报告解读申请列表 4.	api/mm/Interpretation/list page,rows
export async function GetInterpretationList(parameter, msg) {
    return await request.fetchData(global.constants.api_tj + `api/mm/Interpretation/list?page=${parameter.page}&rows=${parameter.rows}`, msg);
}
//新增回复 7.	api/mm/thread/put/add 参数：threadId，content
export async function AddThread(parameter, msg) {
    return await request.postData(global.constants.api_tj + `api/mm/thread/put/add`, parameter, msg);
}
//获取订单详情 /api/am/order/details

export async function GetOrderDetails(orderId, msg) {
    return await request.fetchData(global.constants.api_tj + `api/am/order/details?orderId=${orderId}`, msg);
}
//获取订单支付后返回 api/am/payment/list  OrderNO
export async function GetOrderPayment(OrderNO, msg) {
    return await request.fetchData(global.constants.api_tj + `api/am/payment/list?OrderNO=${OrderNO}`, msg);
}
//获取订单支付后返回预约信息 api/am/payment/isappointment  OrderNO
export async function GetIsappointment(OrderNO, msg) {
    return await request.fetchData(global.constants.api_tj + `api/am/payment/isappointment?OrderNO=${OrderNO}`, msg);
}

//获取用户信息 /api/mm/user/info
export async function GetUserClaims(msg) {
    return await request.fetchData(global.constants.api_tj + `api/mm/user/info`, msg);
}
export  function GetAjaxUserClaims() {   
      return request.ajaxGetData(global.constants.api_tj+ `api/mm/user/info`);
}

//修改支付方式 /api/mm/order/payment/edit
//orderIds （数组），PaymentType，cards（数组）  修改付款方式
export async function EditOrderPayment(parameter, msg) {
    let orderparm = '';
    for (let i = 0; i < parameter.orderIds.length; i++) {
        orderparm += `&orderIds=${parameter.orderIds[i]}`;
    }
    let cardparm = '';
    for (let i = 0; i < parameter.cards.length; i++) {
        cardparm += `&cards=${parameter.cards[i]}`;
    }
    return await request.fetchData(global.constants.api_tj + `api/mm/order/payment/edit?PaymentType=${parameter.PaymentType}${orderparm}${cardparm}`, msg);
}
// 获取退款信息 api/am/order/refund/list
//detailId
export async function GetOrderRefundList(detailId, msg) {
    return await request.fetchData(global.constants.api_tj + `api/am/order/refund/list?detailId=${detailId}`, msg);
}
// 申请退款  /api/am/order/refund/apply
//detailId sum remark 
export async function ApplyOrderRefund(parameter, msg) {
    return await request.fetchData(global.constants.api_tj + `api/am/order/refund/apply?detailId=${parameter.detailId}&sum=${parameter.sum}&remark${parameter.remark}`, msg);
}
//积分转移 /api/bms/order/insert
export async function Insertorder(parameter, msg) {
    return await request.postData(global.constants.api_yg + `api/bms/order/insert`, parameter, msg);
}
//根据时间查询时间段信息 /api/sm/schedule/times
//mcno examDate
export async function GetScheduleTimesSche(parameter, msg) {
    return await request.fetchData(global.constants.api_tj + `api/sm/schedule/times?mcno=${parameter.mcno}&examDate=${parameter.examDate}`, msg);
}
//获取微信配置信息 https://wx-token.tijian.cn/api/apps/signature?appId=wxf1704065b890b66e
export async function GetSignature(url,msg)
{
    return await request.fetchData(global.constants.api_wx+'api/apps/signature?appId=wxf1704065b890b66e&url='+url,msg)
}
//修改登录密码 /api/user/change/psw
//oldPsw
//newPsw
export async function EditChangePSW(parameter, msg)
{
    return await request.postData(global.constants.api_sso+'api/user/change/psw?oldPsw='+parameter.oldPsw+'&newPsw='+parameter.newPsw,'',msg);
}
//修改登录名 /api/user/change/loginname 
//oldLoginName
//newLoginName
export async function EditChangeLoginName(parameter, msg)
{
    return await request.postData(global.constants.api_sso+'api/user/change/loginname',parameter,msg);
}
//微信解绑 /api/user/unbind/weixin
//openId
export async function UnbindWeixin(parameter, msg)
{
    return await request.postData(global.constants.api_sso+'api/user/unbind/weixin?openId='+parameter.openId,'',msg);
}
//获取用户详情 /api/user/logins
export async function UserLogins( msg)
{
    return await request.fetchData(global.constants.api_sso+'api/user/logins',msg);
}
//首页轮播和广告位图片上传
//api/stm/advertisement/list
export async function GetadvertisementList(alias,msg)
{
    return await request.fetchData(global.constants.api_tj+'api/stm/advertisement/list?alias='+alias,msg);
}